import { render, staticRenderFns } from "./BaseTableGrouped.vue?vue&type=template&id=138a1e3e"
import script from "./BaseTableGrouped.vue?vue&type=script&lang=js"
export * from "./BaseTableGrouped.vue?vue&type=script&lang=js"
import style0 from "./BaseTableGrouped.vue?vue&type=style&index=0&id=138a1e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports